<div class="account-card" *ngIf="monthlyPensionAccount as account">
  <div class="d-flex justify-content-between">
    <div class="d-flex gap-2">
      <span class="title-sm">{{ account?.monthlyPensionAccountDetails | monthlyPensionAnnuityTypeLabel }}</span>
      <app-ip-account-status-menu
        *ngIf="showStatusMenu; else statusPill"
        [account]="account"
        [allowStrike]="true"
        (statusSelected)="statusSelected.emit($event)" />
      <ng-template #statusPill>
        <app-status-pill
          [statusPill]="account.statusId === MemberAccountStatusIdEnum.Active | memberActiveStatusPill" />
      </ng-template>
      <app-status-pill *ngIf="hasSplitLegs | splitStatusPill as splitPill" [statusPill]="splitPill" />
    </div>
    <app-text-button
      *ngIf="
        account.statusId === MemberAccountStatusIdEnum.Active ||
        isStruck ||
        (account.statusId === MemberAccountStatusIdEnum.Inactive && !(isMemberPortal$ | async))
      "
      [type]="ButtonTypeEnum.accent"
      [disabled]="effectiveDateInFuture || isStruck"
      (buttonClicked)="goToAccount(account.id)">
      <div class="d-flex align-items-center gap-2">
        <span i18n>View Account</span>
        <div>
          <img [src]="iconButtonSrc" aria-hidden="true" alt="" [style.height.rem]="1.125" [style.width.rem]="1.125" />
        </div>
      </div>
    </app-text-button>
    <app-text-button
      *ngIf="account.statusId === MemberAccountStatusIdEnum.Inactive && (isMemberPortal$ | async)"
      [type]="ButtonTypeEnum.accent"
      (buttonClicked)="goToSubmission()">
      <div class="d-flex align-items-center gap-2">
        <span i18n>View Submission</span>
        <div>
          <img [src]="iconButtonSrc" aria-hidden="true" alt="" [style.height.rem]="1.125" [style.width.rem]="1.125" />
        </div>
      </div>
    </app-text-button>
  </div>
  <div class="details">
    <div class="account-id">{{ account.id | leadingZero : 8 }}</div>
    <div class="description-and-balance">
      <span class="title-md" *ngIf="!effectiveDateInFuture" i18n>{{ monthlyAmount | currency }} /mo</span>
      <span class="description-text" *ngIf="descriptionText" i18n>{{ descriptionText }}</span>
    </div>
  </div>
</div>
